/**
 * 默认磁贴应用列表
 * @type string[]
 */
export const defaultTileAppCodes = [
    'video',
    'udmp',
    'system-manage',
    'permission',
    'device-manage',
    'twin-model',
    'studio'
];

export interface DeskTileItem {
    x: number;
    y: number;
    w: number;
    h: number;
}

export type DeskTileLayout = DeskTileItem[];

export const defaultTileLayout: DeskTileLayout = [
    {
        x: 0,
        y: 0,
        w: 2,
        h: 2
    },
    {
        x: 2,
        y: 0,
        w: 2,
        h: 2
    },
    {
        x: 4,
        y: 0,
        w: 2,
        h: 1
    },
    {
        x: 4,
        y: 1,
        w: 2,
        h: 1
    },

    {
        x: 0,
        y: 2,
        w: 2,
        h: 2
    },
    {
        x: 2,
        y: 2,
        w: 2,
        h: 2
    },
    {
        x: 4,
        y: 2,
        w: 2,
        h: 1
    },
    {
        x: 4,
        y: 3,
        w: 2,
        h: 1
    }
];
